import PropTypes from 'prop-types';

import { css } from '@gogame/ui/styles';

import styled from '../../styled';
import {
  H1Text,
  H2Text,
  H3Text,
  H4Text,
  H5Text,
  H6Text,
  Subtitle1Text,
  Subtitle2Text,
  Body1Text,
  Body2Text,
  ButtonText,
  CaptionText,
  OverlineText,
} from './components';

//@todo rewrite project to material-ui Typography
export const LegacyText = styled(
  ({ color, variant, spacing, type: omittedType, children, ...props }) => {
    let TextComponent = null;

    switch (variant) {
      case 'h1':
        TextComponent = H1Text;
        break;

      case 'h2':
        TextComponent = H2Text;
        break;

      case 'h3':
        TextComponent = H3Text;
        break;

      case 'h4':
        TextComponent = H4Text;
        break;

      case 'h5':
        TextComponent = H5Text;
        break;

      case 'h6':
        TextComponent = H6Text;
        break;

      case 'subtitle1':
        TextComponent = Subtitle1Text;
        break;

      case 'subtitle2':
        TextComponent = Subtitle2Text;
        break;

      case 'body2':
        TextComponent = Body2Text;
        break;

      case 'button':
        TextComponent = ButtonText;
        break;

      case 'caption':
        TextComponent = CaptionText;
        break;

      case 'overline':
        TextComponent = OverlineText;
        break;

      case 'body1':
      default:
        TextComponent = Body1Text;
    }

    return (
      <TextComponent spacing={spacing} {...props}>
        {children}
      </TextComponent>
    );
  }
)`
  ${(props) => {
    //todo: need fix use colors by typography and mui theme

    if (props.type && !props.theme.palette.hasOwnProperty(props.type)) {
      throw new Error(`LegacyText don't supported type=${props.type}`);
    }

    return (
      props.type &&
      css`
        color: ${props.theme.palette[props.type].main};
      `
    );
  }}
`;

LegacyText.displayName = 'Text';
LegacyText.defaultProps = {
  variant: 'body2',
  spacing: 'normal',
};
LegacyText.propTypes = {
  variant: PropTypes.oneOf([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'button',
    'caption',
    'overline',
  ]),
  /**
   * Color intensity.
   */
  intensity: PropTypes.oneOf([100, 200, 300]),

  /**
   * Font weight
   */
  font: PropTypes.oneOf(['light', 'regular', 'medium']),

  /**
   * Italic font
   */
  italic: PropTypes.bool,

  /**
   * Letter spacing
   */
  spacing: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['normal'])]),

  /**
   * Font size
   */
  size: PropTypes.string,

  /**
   * Underline text decoration
   */
  lineThrough: PropTypes.bool,

  /**
   *  White space pre-wrap
   */
  lineBreaks: PropTypes.bool,

  /**
   * Hidden overflow and ellipsis
   */
  ellipsis: PropTypes.bool,

  /**
   * 100% width and display inline-block
   */
  fluid: PropTypes.bool,

  /**
   * Lowercase all words
   */
  lowercase: PropTypes.bool,

  /**
   * Uppercase all words
   */
  uppercase: PropTypes.bool,

  /**
   * User select none
   */
  userSelect: PropTypes.string,

  /**
   * Text align
   */
  align: PropTypes.oneOf(['left', 'center', 'right', 'justify']),
  /**
   * Line clamp
   */
  lineClamp: PropTypes.number,
  /**
   * Word break
   */
  wordBreak: PropTypes.string,
};

export default LegacyText;
